/**
 * Catálogo de sandboxes disponibles.
 *
 * El registro declara `{ type: 'sandbox', demo: '<clave>' }`; aquí se traduce
 * a componente. El test de cobertura comprueba que toda clave existe.
 */

import MenuSandbox from './MenuSandbox';
import RackSandbox from './RackSandbox';
import ListSandbox from './ListSandbox';
import ThemeSandbox from './ThemeSandbox';

export const SANDBOXES = {
  menu: MenuSandbox,
  rack: RackSandbox,
  list: ListSandbox,
  theme: ThemeSandbox,
};

export const SANDBOX_IDS = Object.keys(SANDBOXES);
